import DateFilter from '@/components/date-filter';
import store_operation from "@/store/mods/caisse/operations"
import ManageActionCreanceAssurance from '@/components/comptable/creance/manage-action-creance-assurance'
import $ from 'jquery'

export default {
    name: 'facture-assurance-societe',
    components: {
        DateFilter, ManageActionCreanceAssurance
    },
    props: {
        user_info: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            is_month: true,
            current_date_filter: {},
            curr_month: null,
            filter_date: '',

            liste_factures: [],

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            fields: [
                { key: 'no', label: 'N°' },
                { key: 'reference', label: 'Référence' },
                { key: 'assurance', label: 'Assurance/Société' },
                { key: 'etat', label: 'État' },
                { key: 'date_arret', label: 'Date arrêt' },
                { key: 'date_paiement', label: 'Dernier versement' },
                { key: 'mnt_du', label: 'Montant dû' },
                { key: 'mnt_recu', label: 'Montant reçu' },
                { key: 'action', label: 'Action.s' }
            ],

            search_filter: "",
            perPage: 25,
            currentPage: 1,
            total_pages: 0,

            is_loading: true,
            is_empty: false,
            is_load_error: false,
            selected_facture: {},
            action_toggler: 0,
            mode_suivi: 'relance',
            detail_toggler: 0,
            historique_toggler: 0,
            payment_toggler: 0,
            selected_facture_detail: [],
            is_assurance_bill: true,
            is_facture: 1
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month(month) {
            if (!month || !month.id) return
            if (this.is_month && Number(this.current_date_filter.month) === Number(month.id)) return
            const data = {
                month: month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.currentPage = 1
            this.filter_date = ''
            this.current_date_filter = data
            this.is_month = true
            this.fetchFacturesAssurance()
        },
    },

    computed: {

    },

    mounted() {
        const currentMonth = Number(this.setDates().today_date.split('-')[1])
        this.curr_month = this.list_months[currentMonth]
        const data = {
            month: currentMonth,
            one_date: "",
            from_date: "",
            to_date: "",
        }
        this.current_date_filter = data
        this.is_month = true
        this.fetchFacturesAssurance()
    },

    methods: {
        fetchFacturesAssurance() {
            this.is_load_error = false
            this.is_loading = true

            this.current_date_filter.data_type = 'remboursement_assurance'
            store_operation.getFactureAssuranceSociete(this.current_date_filter).then((response) => {
                this.liste_factures = response.data
                this.total_pages = response.last_page
                if (this.liste_factures.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_load_error = true
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour
            }
            this.current_date_filter = data
            this.currentPage = 1
            this.curr_month = null
            this.filter_date = ""
            this.is_month = false

            this.fetchFacturesAssurance()
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.current_date_filter.page = this.currentPage
                this.fetchFacturesAssurance()
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.current_date_filter.page = this.currentPage
                this.fetchFacturesAssurance()
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.current_date_filter.page = this.currentPage
                this.fetchFacturesAssurance()
            }
        },

        async showDetails(data) {
            this.is_assurance_bill = (data.is_assurance == 1)?true:false
            this.selected_facture = {
                assurance_id: data.assurance_id,
                assurance: data.assurance,
                souscripteur_id: data.souscripteur_id,
                souscripteur: data.souscripteur,
                sum_part_assureur: data.montant_arrete,
                reference: data.reference,
                periode: data.periode_facture,
                date: data.date_arret_facture
            }
            this.current_date_filter.facture_id = data.id
            this.current_date_filter.assurance_id = data.assurance_id
            this.current_date_filter.souscripteur_id = (data.souscripteur_id != null)?data.souscripteur_id:''
            await store_operation.getDetailFactureAssuranceSociete(this.current_date_filter).then((response) => {
                this.selected_facture_detail = response
                this.detail_toggler = (this.detail_toggler == 0)?1:0
                setTimeout(() => {
                    $('.show-detail-bill').modal('show')
                }, 100);
            })
        },

        deposerFacture(data) {
            this.action_toggler = (this.action_toggler == 0)?1:0
            this.is_assurance_bill = (data.is_assurance == 1)?true:false
            this.selected_facture = {
                assurance_id: data.assurance_id,
                assurance: data.assurance,
                souscripteur_id: data.souscripteur_id,
                souscripteur: data.souscripteur,
                sum_part_assureur: data.montant_arrete,
                facture_id: data.id,
                reference: data.reference
            }
            setTimeout(() => {
                $('.depot-creance').modal('show')
            }, 100);
        },

        relancerFacture(data) {
            this.mode_suivi = 'relance'
            this.action_toggler = (this.action_toggler == 0)?1:0
            this.is_assurance_bill = (data.is_assurance == 1)?true:false
            this.selected_facture = {
                assurance_id: data.assurance_id,
                assurance: data.assurance,
                souscripteur_id: data.souscripteur_id,
                souscripteur: data.souscripteur,
                sum_part_assureur: data.montant_arrete,
                facture_id: data.id,
                reference: data.reference
            }
            setTimeout(() => {
                $('.relance-creance').modal('show')
            }, 100);
        },

        programmerRendezVousPaiement(data) {
            this.mode_suivi = 'rendez_vous_paiement'
            this.action_toggler = (this.action_toggler == 0)?1:0
            this.is_assurance_bill = data.is_assurance == 1
            this.selected_facture = {
                assurance: data.assurance,
                souscripteur: data.souscripteur,
                sum_part_assureur: data.montant_arrete,
                facture_id: data.id,
                reference: data.reference
            }
            setTimeout(() => { $('.relance-creance').modal('show') }, 100)
        },

        historiqueFacture(data) {
            console.log(">> d: ",data);
            this.historique_toggler = (this.historique_toggler == 0)?1:0
            this.is_assurance_bill = (data.is_assurance == 1)?true:false
            this.selected_facture = {
                assurance_id: data.assurance_id,
                assurance: data.assurance,
                souscripteur_id: data.souscripteur_id,
                souscripteur: data.souscripteur,
                sum_part_assureur: data.montant_arrete,
                montant_recu: (data.info_complementaire.montant_paye)?parseInt(data.info_complementaire.montant_paye):0,
                facture_id: data.id,
                reference: data.reference
            }

            setTimeout(() => {
                $('.historique-creance').modal('show')
            }, 100);
        },

        payerFacture(data) {
            this.payment_toggler = (this.payment_toggler == 0)?1:0
            this.is_assurance_bill = (data.is_assurance == 1)?true:false
            this.selected_facture = {
                assurance_id: data.assurance_id,
                assurance: data.assurance,
                souscripteur_id: data.souscripteur_id,
                souscripteur: data.souscripteur,
                sum_part_assureur: data.montant_arrete,
                facture_id: data.id,
                reference: data.reference
            }
            setTimeout(() => {
                $('.paiement-facture').modal('show')
            }, 100);
        },

        gotToFactureEncours() {
            this.$emit('emitToggleView')  
        },

        setInvoiceToPrint(invoice_data) {
            this.$emit('emitInvoiceSetter', invoice_data)
        }
    }
}
